import { Snackbar } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FeedBack = styled(Snackbar)({
  [`&.MuiSnackbar-root`]: {
    zIndex: 2000,
  },
});
